// extracted by mini-css-extract-plugin
module.exports = {"alert":"notificationmenuitem_alert__1Qyq7","item":"notificationmenuitem_item__1LfkO"};